import React from "react"
import { Line } from "./colorLine.style"

export const ColoredLineView = ({ color = "", height = "0.1px", width = "0px" }) => (
  <Line color={color} height={height} width={width}/>
)
